import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { TimeZones } from '../../../../../../generated/graphql-types';
import { GetExtensionDetail_extension_extensionPhone } from '../../queries/generated/GetExtensionDetail';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-extension-phone-detail-left-column',
    styleUrls: ['./extension-phone-detail-left-column.component.scss', '../extension-detail-view.component.scss'],
    templateUrl: './extension-phone-detail-left-column.component.html',
    standalone: false
})
export class ExtensionPhoneDetailLeftColumnComponent {
   @Input() extensionPhone: GetExtensionDetail_extension_extensionPhone | null;

   @Input() timeZoneId: TimeZones | null;

   @Input() dndStatus: string | null;

   @Input() domain: string;

   @Input() isSystemUser: boolean;

   @Output() changeDNDStatus = new EventEmitter<string | null>();

   onDNDStatusChangeClick() {
      this.changeDNDStatus.emit(this.extensionPhone?.dndStatus);
   }
}
